import React from "react";
import MenuPage from "../menu_page/menu_page";

export default function MenuOnlyPage({ match }) {
  return <MenuPage match={match} menuOnly />;
}
